module.exports = __webpack_public_path__ + "img/ERTIGA-XL72021.5739f5b0.png";